import Head from "next/head";

export default function HeaderPage({ title, content }: { title?: string, content?: string }) {
  return (
    <Head>
      <title>{title || 'GV Management System'}</title>
      <meta name="description" content={content || "GV Motorcycle Management System"} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Head>
  );
}